import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from '../guards/auth.guard.service';
import { DeactivatedGuardService } from '../guards/deactivate-guard.service';
import { EditComponent } from './components/edit/edit.component';
import { CustomerComponent } from './customer.component';


const customerRoutes: Routes = [{
    path: 'customers', component: CustomerComponent,
    //canActivate: [AuthGuardService],
    children: [
        {
            path: 'edit/:id', component: EditComponent,
            // canDeactivate: [DeactivatedGuardService] 
        },
        { path: 'add', component: EditComponent },
    ]

}
];

@NgModule({
    imports: [RouterModule.forChild(customerRoutes)],
    exports: [RouterModule]
})
export class CustomerRoutingModule { }

